import React, { Component } from 'react';
import CheckBoxList from './modules/checkboxlist'

class App extends Component{
  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className="App">
        <CheckBoxList  />
      </div>
    );
  }
}

export default App;